import React, { useState } from 'react';

const InfoBoxes = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ title: '', body: '' });

  const modalContents = {
    'about-association': {
      title: 'انجمن علمی چیست؟',
      body: `
        <p>انجمن‌های علمی دانشجویی، نهادهای خودگردان و غیرسیاسی هستند که توسط دانشجویان و برای دانشجویان اداره می‌شوند. این انجمن‌ها با هدف گسترش فعالیت‌های علمی، پژوهشی و فرهنگی در سطح دانشگاه فعالیت می‌کنند.</p>
        <p>اهداف اصلی انجمن‌های علمی:</p>
        <ul>
          <li>ایجاد بستری برای تبادل دانش و تجربیات علمی بین دانشجویان</li>
          <li>برگزاری کارگاه‌های آموزشی، همایش‌ها و نشست‌های تخصصی</li>
          <li>ارتباط با صنعت و مراکز تحقیقاتی</li>
          <li>کمک به ارتقای سطح علمی دانشجویان</li>
          <li>ایجاد فرصت‌های رشد و توسعه فردی و حرفه‌ای</li>
        </ul>
        <p>عضویت در انجمن‌های علمی و فعالیت در آن‌ها، فرصتی ارزشمند برای کسب تجربه، توسعه مهارت‌های فردی و شبکه‌سازی با دیگر دانشجویان و اساتید است.</p>
      `
    },
    'importance-voting': {
      title: 'چرا رأی دادن مهم است؟',
      body: `
        <p>مشارکت در انتخابات انجمن‌های علمی، یکی از مهم‌ترین راه‌های تأثیرگذاری شما بر آینده علمی دانشگاه است. رأی شما به معنای تعیین افرادی است که در سال آینده نماینده شما در تصمیم‌گیری‌های علمی خواهند بود.</p>
        <p>اهمیت رأی دادن در انتخابات انجمن‌های علمی:</p>
        <ul>
          <li>تعیین جهت‌گیری فعالیت‌های علمی دانشگاه</li>
          <li>انتخاب نمایندگانی که اهداف و دیدگاه‌های شما را نمایندگی می‌کنند</li>
          <li>مشارکت در تقویت دموکراسی دانشجویی</li>
          <li>ایجاد حس تعلق و مشارکت در جامعه دانشگاهی</li>
          <li>تأثیرگذاری بر کیفیت برنامه‌ها و فعالیت‌های آینده انجمن</li>
        </ul>
        <p>به یاد داشته باشید، هر رأی مهم است و می‌تواند مسیر انجمن علمی شما را تغییر دهد. با مشارکت در انتخابات، آینده علمی دانشگاه خود را شکل دهید.</p>
      `
    },
    'role-associations': {
      title: 'نقش انجمن‌ها در دانشگاه شمال',
      body: `
        <p>انجمن‌های علمی در دانشگاه شمال آمل نقشی کلیدی در ارتقای سطح علمی و پژوهشی دانشگاه دارند. این انجمن‌ها به عنوان بازوی اجرایی و علمی دانشکده‌ها، فعالیت‌های متنوعی را برای دانشجویان برگزار می‌کنند.</p>
        <p>نقش‌های کلیدی انجمن‌های علمی در دانشگاه شمال:</p>
        <ul>
          <li>برگزاری مسابقات علمی و المپیادهای تخصصی</li>
          <li>ارائه کارگاه‌های آموزشی برای ارتقای مهارت‌های فنی و نرم</li>
          <li>ارتباط با صنعت و برگزاری بازدیدهای صنعتی</li>
          <li>حمایت از پروژه‌های دانشجویی و ایده‌های نوآورانه</li>
          <li>ایجاد پل ارتباطی بین دانشجویان و اساتید</li>
          <li>نشر علمی و انتشار نشریات تخصصی</li>
        </ul>
        <p>در دانشگاه شمال، انجمن‌های علمی به عنوان موتور محرک علمی و پژوهشی دانشجویان شناخته می‌شوند و تلاش می‌کنند تا محیطی پویا و علمی برای رشد و تعالی دانشجویان فراهم کنند.</p>
      `
    }
  };

  const openModal = (contentId) => {
    setModalContent(modalContents[contentId]);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <section className="info-boxes">
        <div className="container">
          <div className="section-title">
            <h2>بیشتر بدانید</h2>
            <p>اطلاعات مفید درباره انجمن‌های علمی و اهمیت مشارکت</p>
          </div>
          <div className="info-boxes-grid">
            <div className="info-box">
              <div className="info-icon">
                <i className="fas fa-graduation-cap"></i>
              </div>
              <h3>انجمن علمی چیست؟</h3>
              <p>مکانی برای رشد علمی و تبادل ایده‌ها بین دانشجویان</p>
              <button className="btn" onClick={() => openModal('about-association')}>بیشتر بدانید</button>
            </div>
            <div className="info-box">
              <div className="info-icon">
                <i className="fas fa-vote-yea"></i>
              </div>
              <h3>چرا رأی دادن مهم است؟</h3>
              <p>نقش تو در آینده علمی دانشگاه و دانشکده تأثیرگذار است </p>
              <button className="btn" onClick={() => openModal('importance-voting')}>اهمیت مشارکت</button>
            </div>
            <div className="info-box">
              <div className="info-icon">
                <i className="fas fa-rocket"></i>
              </div>
              <h3>نقش انجمن‌ها در دانشگاه شمال</h3>
              <p>انجمن‌ها بازوی علمی دانشگاه هستند و بستری برای نوآوری</p>
              <button className="btn" onClick={() => openModal('role-associations')}>بیشتر بخوانید</button>
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      {modalOpen && (
        <div id="infoModal" className="modal" style={{ display: 'block' }}>
          <div className="modal-content">
            <div className="modal-header">
              <h2 id="modal-title">{modalContent.title}</h2>
              <span className="close" onClick={closeModal}>&times;</span>
            </div>
            <div className="modal-body" id="modal-body" dangerouslySetInnerHTML={{ __html: modalContent.body }}></div>
            <div className="modal-footer">
              <button className="btn" id="modal-close" onClick={closeModal}>بستن</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InfoBoxes;